import script from "./OidoQuantityInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoQuantityInput.vue?vue&type=script&setup=true&lang=js"

import "./OidoQuantityInput.vue?vue&type=style&index=0&id=47b7baec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b7baec"]])

export default __exports__